import React from "react";
import setWindowLocationHref from "~/common/navigation/setWindowLocationHref";
interface Props {
  productLink: string;
  containsQuantityDropdown?: boolean;
  showQuantityDropdown?: boolean;
}
const ViewDetailsButton = ({
  productLink,
  containsQuantityDropdown,
  showQuantityDropdown
}: Props) => {
  const handleViewDetailsClick = (event: React.SyntheticEvent) => {
    event?.preventDefault();
    setWindowLocationHref(productLink);
  };
  return <div className={`add-to-cart ${!showQuantityDropdown && containsQuantityDropdown ? "absolute" : ""}`} style={!showQuantityDropdown && containsQuantityDropdown ? {
    bottom: "8px",
    width: "130px"
  } : {}} data-sentry-component="ViewDetailsButton" data-sentry-source-file="ViewDetailsButton.tsx">
      <div className="btn-container p-0">
        <input type="button" className="btn btn-cart btn-small" value="View Details" onClick={handleViewDetailsClick} data-testid="carousel-view-details-button" />
      </div>
    </div>;
};
export default ViewDetailsButton;